export default "__VITE_ASSET__CswOtkit__"